import styled from 'styled-components/native';

import { bloom, tangerine, white } from '../../../constants/color';
import { GET_LAYOUT_MAX_WIDTH } from '../../../constants/layout';
import Image from '../../../elements/Image';
import LinearGradient from '../../../elements/LinearGradient';
import Touchable from '../../../elements/Touchable';
import { OnSaleItemHeight } from './OnSaleItem';

const PADDING_TOP = 6;
const MARGIN_TOP = 2;
const PADDING_BOTTOM = 8;
const MARGIN_BOTTOM = 20;
const MARGIN_HORIZONTAL = 15;
const TITLE_LINE_HEIGHT = 20;

export const getOnSaleListHeight = fontScale => {
  return (
    PADDING_TOP +
    MARGIN_TOP +
    TITLE_LINE_HEIGHT * fontScale +
    OnSaleItemHeight(fontScale) +
    PADDING_BOTTOM +
    MARGIN_BOTTOM
  );
};

export const linearGradientProps = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
  colors: [tangerine, bloom],
};

export default {
  Structure: styled.View`
    width: ${() => GET_LAYOUT_MAX_WIDTH() - MARGIN_HORIZONTAL * 2}px;
    margin: 0px ${MARGIN_HORIZONTAL}px ${MARGIN_BOTTOM}px ${MARGIN_HORIZONTAL}px;
  `,
  Container: styled(LinearGradient)`
    width: 100%;
    background-color: ${white};
    margin-top: ${MARGIN_TOP}px;
    padding: ${PADDING_TOP}px 0 ${PADDING_BOTTOM}px;
    border-radius: 10px;
  `,
  TitleContainer: styled.View`
    margin: 0 12px;
    flex-direction: row;
  `,
  Title: styled.Text`
    color: ${white};
    font-size: 13px;
    line-height: ${TITLE_LINE_HEIGHT}px;
  `,
  Blank: styled.View`
    flex: 1;
  `,
  Banner: styled.View`
    width: 100%;
    position: absolute;
    z-index: 5;
    align-items: center;
  `,
  BannerBackground: styled(Image)`
    width: 155px;
    height: 30px;
  `,
  BannerText: styled.Text`
    position: absolute;
    color: ${white};
    font-size: 20px;
    line-height: 30px;
  `,
  TitleRight: styled(Touchable)`
    flex-direction: row;
    align-items: center;
  `,
  IconContainer: styled.View`
    width: 12px;
  `,
  ListHeader: styled.View`
    width: 12px;
  `,
  ListFooter: styled(Touchable)`
    align-items: center;
    justify-content: center;
    padding: 4px;
    margin: auto 0;
  `,
  ListFooterText: styled.Text`
    color: ${white};
    font-size: 15px;
    line-height: 21px;
    margin: 4px;
  `,
  ListFooterIcon: styled.View`
    margin: 4px;
  `,
};
